module.exports = __webpack_public_path__ + "magicbeans_cases.jpg?528b6197a8fa8e9cec98dc93dd07124a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cases/magicbeans_cases.jpg
// module id = 88
// module chunks = 0